import styled from 'styled-components';
import Flex from '../../atoms/Flex';
export const MiniatureItem = styled(Flex).attrs(props => ({
  borderWidth: props.selected ? 2 : 1,
  borderColor: props.selected ? 'blue' : 'whisper',
  borderStyle: 'solid',
  borderRadius: 'default',
  padding: 2,
  width: props.smallThumbnails ? '84px' : '110px',
  height: props.smallThumbnails ? '66px' : '110px',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  position: 'relative'
}))`
  & img {
    height: ${props => props.smallThumbnails ? '70px' : '90px'};
  }
`;